export class ContainerEngine {
    #label;
    #className;

    static #map = {
        std: new ContainerEngine('std', '.container-std'),
        xs: new ContainerEngine('xs', '.container-xs'),
        sm: new ContainerEngine('sm', '.container-sm'),
        md: new ContainerEngine('md', '.container-md'),
        lg: new ContainerEngine('lg', '.container-lg'),
        xl: new ContainerEngine('xl', '.container-xl'),
        xxl: new ContainerEngine('xxl', '.container-xxl'),
    };

    /**
     *
     * @param label {string}
     * @return {ContainerEngine}
     */
    static find(label) {
        if (!ContainerEngine.#map[label]) {
            throw new Error(`No value found for ${label}`);
        }
        return ContainerEngine.#map[label];
    }

    constructor(label, className) {
        this.#label = label;
        this.#className = className;
    }

    /**
     *
     * @return {string}
     */
    get label() {
        return this.#label;
    }

    /**
     *
     * @return {string}
     */
    get className() {
        return this.#className;
    }

    /**
     *
     * @return {HTMLElement | undefined}
     */
    get #ContainerEngine() {
        const containerElement = document.querySelector(this.className);
        if (containerElement !== null) {
            return containerElement;
        } else {
            throw new Error(`No container element found with class: ${this.className}`);
        }
    }

    /**
     *
     * @return {number}
     */
    get offsetX() {
        return this.#ContainerEngine.getBoundingClientRect().x;
    }

}
